
import { Component } from '@angular/core';
import { QuickLinksCardComponent } from '../quick-links-card/quick-links-card.component';

@Component({
  selector: 'app-split-page',
  templateUrl: './split-page.component.html',
  styleUrls: ['./split-page.component.scss'],
  imports: [QuickLinksCardComponent],
})
export class SplitPageComponent {
}
